<template>
  <div :class="validationContainerClass" class="mb-3">
    <label :for="id"
      >{{ label }}
      <div v-if="isRequired" class="is-required">
        <i class="fas fa-star-of-life"></i>
      </div>
    </label>
    <vue2-tinymce-editor
      v-model="content"
      :options="options"
    ></vue2-tinymce-editor>
  </div>
</template>

<script>
import InputCommons from "./InputCommons.vue";

import { Vue2TinymceEditor } from "vue2-tinymce-editor";

export default {
  extends: InputCommons,
  components: { Vue2TinymceEditor },

  data() {
    return {
      options: {
        directionality: "rtl",
      },
    };
  },

  watch: {
    content(value) {
      this.$emit("input", value);
    },
  },
};
</script>
